import React, { Component, Fragment } from "react"
import PropTypes from "prop-types"
import { observer } from "mobx-react"
import { Table } from "semantic-ui-react"
import _ from "lodash"
import ProductRowDefault from "components/Product/ProductRowDefault"
import Responsive                                                from "react-responsive"

@observer
export default class ProductTable extends Component {
  static propTypes = {
    list    : PropTypes.object,
    cart    : PropTypes.object,
    onChange: PropTypes.func,
    products: PropTypes.array,
  }
  
  render() {
    let { list, cart, products, onChange, readOnly, available} = this.props
    let ProductRow = this.props.row || ProductRowDefault
    let positions = list || products
    if ( list ) positions = list.products
    positions = _.sortBy( positions, function(p) { return (p && p.extras && p.extras.stockColor && p.extras.stockColor.value && p.extras.stockColor.value.value === "green") ? 0 : 1 } )
    console.log("positions ARTICLEOPEN", positions)
    let rows = _.map( positions, ( product, index ) => {
      return (<Fragment>
            <ProductRow key={index} index={index} available={available} readOnly={readOnly} onChange={onChange} list={list} cart={cart} product={product}/>
            </Fragment>
      )
    } )
    return (
        <Fragment>
        <Responsive maxWidth={789}>
          <table className="mobileRespTable" >
            <colgroup>
              <col width="10%"/>
              <col width="90%"/>
              </colgroup>
            <tbody>
            {rows}
            </tbody>
          </table>
        </Responsive>
        <Responsive minWidth={790}>
      <Table>
        <colgroup>
          <col width="25"/>
          <col width=""/>
          <col width="15%"/>
          <col width="10%"/>
          <col width="15%"/>
          <col width="15%"/>
          <col width="15%"/>
        </colgroup>
        <thead>
        <tr  className="cssOptima">
          <th>&nbsp;</th>
          <th>{translate( "article" )}</th>
          {/*<th>&nbsp;</th>*/}
          <th className="tl">{translate( "deliverable" )}</th>
          {/*<th>Preis/Stück</th>*/}
          {/*<th>{translate( "deliverable" )}</th>*/}
          {/*<th>{translate("Preis/Stück")}</th>*/}
          
          <th>{translate( "KE pro VE" )}</th>
          <th>{translate( "Brutto EK* pro VE" )}</th>
          {/*<th>{translate( "total count" )}</th>*/}
          <th>
            {!readOnly ?<div className="tr">
              {translate( "Summe Brutto EK*" )}
            </div> : <div className="tr">
              {translate( "Menge in VE" )}
            </div>}
          </th>
          {/*<th>{translate( "VE" )}</th>*/}
          {/*<th style={{textAlign: "right"}}>{translate( "amount (VE)" )}</th>*/}
          {list && <th style={{ textAlign: "right" }}>{translate( "" )}</th>}
          {!readOnly && <th>{translate( "Menge in VE" )}</th>}
          {readOnly && <th className="">
            <div className="fr">{translate( "Summe Brutto EK*" )}</div></th>}
        </tr>
        </thead>
        <tbody>
        {rows}
        </tbody>
      </Table>
        </Responsive>
      </Fragment>
    )
  }
}







// WEBPACK FOOTER //
// ./src/theme/lindtbShop/components/Product/ProductTable.js